import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import FeatureFlags from "@assets/constantes/feature-flags.json";
import Permissions from "@assets/constantes/permisos.json";

import { FeatureFlagGuard } from "@shared/Guards/feature-flag-guard";
import { NeverActivateGuard } from "@shared/Guards/never-activate.guard";
import { UserHasPermissionGuard } from "@shared/Guards/user-has-permission.guard";
import { getRouteSection } from "@shared/Utils/get-route-details.util";

import { NotFoundComponent } from "../ErrorPages/NotFound/notfound.component";
import { HomeEnLineaComponent } from "../Home/home-en-linea/home-en-linea.component";

import { PortalesComponent } from "./portales.component";

const getPageDetails = getRouteSection("portales");

const routes: Routes = [
  {
    path: "",
    component: PortalesComponent,
    data: {
      title: "Universal En Línea",
    },
    children: [
      {
        path: "",
        component: HomeEnLineaComponent,
      },
      {
        path: "administracion",
        loadChildren: () => import("../Administration/administration.module").then((m) => m.AdministrationModule),
      },
      {
        path: "canales",
        data: {
          title: "Canales",
        },
        loadChildren: () => import("../Canales/canales.module").then((m) => m.CanalesModule),
      },
      {
        path: "perfiles",
        canActivate: [NeverActivateGuard],
        loadChildren: () => import("../Perfiles/perfiles.module").then((m) => m.PerfilesModule),
      },
      {
        path: "salasvip",
        data: {
          title: "Salas VIP",
        },
        loadChildren: () => import("../SalasVIP/salas-vip.module").then((m) => m.SalasVIPModule),
      },
      {
        path: "afi",
        data: {
          title: "AFI",
        },
        loadChildren: () => import("../AFI/afi.module").then((m) => m.AFIModule),
      },
      {
        path: "reclamaciones",
        canActivate: [FeatureFlagGuard, UserHasPermissionGuard],
        data: {
          title: "Reclamaciones",
          feature: FeatureFlags.portales.Reclamaciones,
          requiredPermission: Permissions.portales.Reclamaciones,
        },
        loadChildren: () => import("../Reclamaciones/reclamaciones.module").then((m) => m.ReclamacionesModule),
      },
      {
        path: "fiduciaria",
        loadChildren: () => import("../Fiduciaria/fiduciaria.module").then((m) => m.FiduciariaModule),
      },
      {
        path: "encuestas",
        canActivate: [NeverActivateGuard],
        loadChildren: () => import("../Encuestas/encuestas.module").then((m) => m.EncuestasModule),
      },
      {
        path: "indicacionesmedicas",
        data: {
          title: "Indicaciones Médicas",
        },
        loadChildren: () => import("../Indicaciones/indicaciones.module").then((m) => m.IndicacionesMedicasModule),
      },
      {
        path: "salud",
        data: {
          title: "Salud Local",
        },
        loadChildren: () => import("../SaludLocal/salud-local.module").then((m) => m.SaludLocalModule),
      },
      {
        path: "rgvsi",
        data: {
          title: "Riesgos Generales, Vida y Salud Internacional",
        },
        loadChildren: () => import("../RGVSI/RGVSI.module").then((m) => m.RGSVIModule),
      },
      {
        path: "pagos",
        data: {
          title: "Pagos",
        },
        loadChildren: () => import("../Payment/payment.module").then((m) => m.PaymentModule),
      },

      {
        path: "unit",
        data: {
          title: "Unit",
        },
        loadChildren: () => import("../Unit/unit.module").then((m) => m.UnitModule),
      },
      {
        path: "auth",
        loadChildren: () => import("../Auth/auth.module").then((m) => m.AuthModule),
      },
      {
        path: "dashboard",
        loadChildren: () => import("../Dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "manuales",
        ...getPageDetails("manuals"),
        loadChildren: () => import("../Manuals/manuals.module").then((m) => m.ManualsModule),
      },
      {
        path: "sugerencias",
        ...getPageDetails("intermediaryNeeds"),
        loadChildren: () => import("../General/IntermediaryIdea/intermediary-idea.module").then((m) => m.IntermediaryIdeaModule),
      },
      {
        path: "**",
        component: NotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortalesRoutingModule {}
